import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';
import { HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class OtherProductService {

  constructor(private apiService: ApiService) { }

  getOtherProducts(queryParams?: HttpParams) {
    return this.apiService.get('other-products', queryParams);
  }
  

  createOtherProduct(data: any) {
    return this.apiService.post('other-products', data);
  }

  getOtherProduct(id: any) {
    return this.apiService.get('other-products/' + id);
  }

  updateOtherProduct(id: any, data: any) {
    return this.apiService.update('other-products/' + id, data);
  }

  deleteOtherProduct(id: any) {
    return this.apiService.delete('other-products/' + id);
  }

  getNextProductCode() {
    return this.apiService.get('other-products-next-code');
  }
}